import { enableAnimDemos } from './pages/pattern-lab/_patterns/60-experiments/animate/animate-demo-helpers.js';
enableAnimDemos();
